import { useGlobalTopicListTabModel } from './global-topic-list-tab.model'
import { GlobalTopicListTabView } from './global-topic-list-tab.view'

export const GlobalTopicListTab = () => {
  const globalTopicListTabModel = useGlobalTopicListTabModel()
  return <GlobalTopicListTabView {...globalTopicListTabModel} />
}
